/* Nida Home - barre "Ajouter au panier" collante (mobile). Par Claude.
   Affiche le prix reel + la ligne "399 EUR avec le code NIDA100" (honnete :
   le client voit le prix paye + l'offre conditionnee au code).
   Se branche sur le bouton d'ajout du theme Dawn et se masque
   automatiquement quand le vrai bouton est visible a l'ecran. */
(function () {
  function init() {
    var realBtn = document.querySelector('.product-form__submit, product-form button[name="add"], product-form [name="add"]');
    var form = realBtn ? realBtn.closest('form') : document.querySelector('product-form form');
    if (!realBtn && !form) return;                 // page produit uniquement
    if (document.getElementById('nida-sticky-atc')) return;

    var priceEl = document.querySelector('.product__info-wrapper .price-item--sale:not(.hidden)')
               || document.querySelector('.product__info-wrapper .price-item--regular')
               || document.querySelector('.product__info-wrapper .price-item');
    var priceText = priceEl ? priceEl.textContent.trim() : '';

    var bar = document.createElement('div');
    bar.id = 'nida-sticky-atc';
    bar.innerHTML =
      '<div class="nida-sticky-atc__inner">' +
        '<span class="nida-sticky-atc__pricewrap">' +
          '<span class="nida-sticky-atc__price">' + priceText + '</span>' +
          '<span class="nida-sticky-atc__deal">399 € avec le code NIDA100</span>' +
        '</span>' +
        '<button type="button" class="nida-sticky-atc__btn">Ajouter au panier</button>' +
      '</div>';
    document.body.appendChild(bar);

    bar.querySelector('.nida-sticky-atc__btn').addEventListener('click', function () {
      if (realBtn) { realBtn.click(); }
      else if (form && form.requestSubmit) { form.requestSubmit(); }
      else if (form) { form.submit(); }
    });

    // Masquer la barre quand le vrai bouton est a l'ecran (evite le doublon)
    if ('IntersectionObserver' in window && realBtn) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { bar.classList.toggle('is-hidden', e.isIntersecting); });
      }, { threshold: 0 }).observe(realBtn);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
